import React, { useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, TablePagination
} from '@mui/material';
import { Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';

import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, postData, updateData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Close as CloseIcon
} from '@mui/icons-material';
import SaveIcon from '@mui/icons-material/Save';

function PositionIndex() {
  const inputRef = useRef(null);
  const [data, setData] = useState([]);
  // const [filteredData, setFilteredData] = useState([]);
  const [editRowId, setEditRowId] = useState(null); // For tracking which row is in edit mode
  const [editedData, setEditedData] = useState({});
  const { isAuthenticated, userId, clubId, token, logout } = useAuth();
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [cancel, setCancel] = useState(false); // State to manage the creation of a new row

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) {
      logout();
      return;
    }
    fetchtableData();
  }, [isAuthenticated, clubId, token, logout]);

  // useEffect(() => {
  //   setFilteredData(data);
  // }, [data]);

  const fetchtableData = async () => {
    fetchData('UserTypesApi', `/${clubId}`, token)
      .then((response) => {
        if (response.responseCode === '1111') {
          setData(response.response_data);
        }
      })
      .catch((error) => {
        console.error('Error fetching User Type Details:', error);
      });
  };

  //handle search [ITEM SEARCH]
  const [isFocused, setIsFocused] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [showSearchInput, setShowSearchInput] = useState(false);

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const toggleSearchInput = () => {
    setShowSearchInput(!showSearchInput);
  };

  //search
  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  // Handle Create Button Click: Add a new row with id = 0 (temporary)
  const handleCreateClick = () => {
    const newRow = {
      Id: 0, // Temporary ID for the new row
      Name: '', // Empty name initially
      IsActive: true // Set it as active by default
    };
    setData([newRow, ...data]); // Add the new row to the top
    setEditRowId(0); // Set the new row in edit mode
    setEditedData(newRow); // Initialize edited data for the new row
    setCancel(true); // Set cancel state to true
  };

  const handleEditClick = (user) => {
    setEditRowId(user.Id); // Set the row in edit mode
    setEditedData(user); // Load the current user data for editing
  };

  const handleInputChange = (e) => {
    setEditedData({
      ...editedData,
      [e.target.name]: e.target.value,
    });
  };

  // Handle Save: If the ID is 0, create a new record, otherwise update the existing one
  const handleSaveClick = async () => {
    if (editedData.Id === 0) {
      // Create new record
      const newUsertypedata = {
        Name: editedData.Name,
        CreatedBy: userId || null,  // Null if userId is falsy (unlikely for userId)
        CreatedDate: new Date(),  // Always generate the current date
        ClubId: clubId || "",
      };

      try {
        const response = await postData('UserTypesApi', newUsertypedata, token); // Assuming createData sends a POST request
        console.log('New record created successfully:', response);

        // Update the table with the real ID from the response
        const updatedData = data.map((user) =>
          user.Id === 0 ? { ...user, Id: response.response_data.Id } : user
        );
        setData(updatedData);

      } catch (error) {
        console.error('Error creating new UserType:', error);
      }
    } else {
      // Update existing record
      const updatedUsertypedata = {
        Id: editedData.Id,
        Name: editedData.Name,
        ClubId: clubId || "",
        ModifiedBy: userId || null,  // Null if userId is falsy (unlikely for userId)
        ModifiedDate: new Date(),
      };

      try {
        const response = await updateData('UserTypesApi', editedData.Id, updatedUsertypedata, token);
        console.log('Record updated successfully:', response);

        // Update the table with the updated record
        const updatedData = data.map((user) =>
          user.Id === editedData.Id ? { ...user, ...updatedUsertypedata } : user
        );
        setData(updatedData);
      } catch (error) {
        console.error('Error updating UserType:', error);
      }
    }

    setEditRowId(null); // Exit edit mode
    setCancel(false); // Reset cancel state
    window.location.reload();
  };

  const handleCancelClick = () => {
    setEditRowId(null); // Exit edit mode
    setCancel(false); // Reset cancel state
    fetchtableData(); // Reload the table data to remove the temporary row
  };

  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('PurchaseOrderDate');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const sortedData = stableSort(filteredData, getComparator(order, orderBy));
  const commonButtonStyles = {
    height: '36px',
    marginLeft: '10px',
    marginTop: '1.00%',
    marginRight: '8px',
  };

  const handleDelete = async () => {
    deleteData('UserTypesApi', `${deleteItemId}`, token)
      .then((response) => {
        fetchtableData();

        setConfirmDialogOpen(false);
      })
      .catch((error) => {
        console.error('Error deleting record:', error);
      });
  };

  const handleActivate = (manuId) => {
    activateData('UserTypesApi', `${manuId}`)
      .then(() => {
        fetchtableData();
      })
      .catch((error) => {
        console.error('Error activating record:', error);
      });
  };

  const openConfirmDialog = (manuId) => {
    setDeleteItemId(manuId);
    setConfirmDialogOpen(true);
  };

  const closeConfirmDialog = () => {
    setDeleteItemId(null);
    setConfirmDialogOpen(false);
  };


  return (
    <div className="w-full max-w-sm container mt-2 mx-auto">
      {/* <div className="w-full mb-2 flex">
        <h6 className="productHead flex-grow linkcolor" style={{ color: '#14528B', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>POSITIONS</h6>
        <Button
          className="linkcolor"
          style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#347928', height: '25px' }}
          onClick={handleCreateClick} 
        >
          <AddIcon /> CREATE
        </Button>
      </div> */}

      <div className='w-full mb-2 flex'>
        <h6 className='productHead flex-grow linkcolor' style={{ color: '#0e728c', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: '#0e728c' }}>POSITIONS</h6>

        <input
          className="shadow text-gray-700 leading-tight"
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={handleSearch}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          style={{
            width: isFocused ? '250px' : '140px',
            height: '30px',
            border: '1px solid #ccc',
            borderRadius: '15px',
            padding: '0 20px',
            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
            outline: 'none',
            borderColor: isFocused ? 'darkcyan' : '#ccc',
            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
            marginLeft: '10px'
          }}
        />

        <div className="button-container-1" style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Tooltip
            title="Create Positions "
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: '#0e728c',
                  color: 'white',
                  border: '1px solid white',
                  fontWeight: 'bold',
                  boxShadow: 2,
                },
              },
            }}
          >
            <Button
              component={Link}
              onClick={handleCreateClick}
              className="linkcolor"
              style={{ color: 'whitesmoke', fontsize: '11px', backgroundColor: '#27391C', height: '25px', marginLeft: '5px' }}
            >
              CREATE
            </Button>
          </Tooltip>
        </div>
      </div>


      <div className="w-full mb-2 flex" style={{ maxHeight: '520px', overflowY: 'auto' }}>
        <TableContainer component={Paper}>
          <Table>
            {/* <TableHead sx={{ backgroundColor: '#0c8bce', fontFamily: 'sans-serif' }}> */}
            <TableHead sx={{ backgroundColor: '#15abd2', fontFamily: 'sans-serif' }}>

              <TableRow>
                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'white', fontWeight: 'bold' }}>Sl No</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'white', fontWeight: 'bold' }}>Position</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '5px', color: 'white', fontWeight: 'bold', textAlign: 'right' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody style={{ backgroundColor: '#F5F7F8' }}>
              {sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((user, index) => (

                <TableRow
                  key={user.Id}
                  className={user.IsActive ? '' : 'inactiveRow'}
                  sx={{
                    backgroundColor: index % 2 === 0 ? 'white' : '#ebf9fd',// Alternate row background colors
                  }}
                >

                  <TableCell sx={{ borderBottom: '1px solid rgb(215, 213, 231)', fontSize: '14px', padding: '3px' }}>{index + 1}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid rgb(226, 223, 240)', fontSize: '14px', padding: '3px' }}>
                    {editRowId === user.Id ? (
                      <input
                        type="text"
                        name="Name"
                        value={editedData.Name || ''}
                        onChange={handleInputChange}
                        style={{ width: '100%' }}
                      />
                    ) : (
                      user.Name
                    )}
                  </TableCell>
                  <TableCell sx={{ borderBottom: '1px solid rgb(226, 223, 240)', fontSize: '14px', padding: '3px', color: 'whitesmoke', textAlign: 'right' }}>
                    {editRowId === user.Id ? (
                      <>
                        <Tooltip title="Save Position">
                          <IconButton onClick={handleSaveClick}>
                            <SaveIcon style={{ fontSize: '20px', color: 'green' }} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Cancel">
                          <IconButton onClick={handleCancelClick}>
                            <CloseIcon style={{ fontSize: '20px', color: 'red' }} />
                          </IconButton>
                        </Tooltip>
                      </>
                    ) : (
                      <Tooltip title="Edit Position">
                        <IconButton onClick={() => handleEditClick(user)}>
                          <EditIcon style={{ fontSize: '20px', color: 'blue' }} />
                        </IconButton>
                      </Tooltip>
                    )}
                    <Tooltip title="Delete Position">
                      <IconButton onClick={() => (user.IsActive ? openConfirmDialog(user.Id) : handleActivate(user.Id))}>
                        {user.IsActive ? <DeleteIcon style={{ fontsize: '20px', color: 'brown' }} /> : <ActivateIcon style={{ fontsize: '20px' }} />}
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <Dialog
              open={confirmDialogOpen}
              onClose={closeConfirmDialog}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you want to delete this record?
                </DialogContentText>
              </DialogContent>

              <DialogActions>
                <button
                  onClick={closeConfirmDialog}
                  style={{
                    backgroundColor: '#dc3545',
                    color: '#ffffff',
                    border: '1px solid #dc3545',
                    borderRadius: '4px',
                    padding: '8px 16px',
                    cursor: 'pointer',
                    marginRight: '8px',
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleDelete}
                  style={{
                    backgroundColor: '#28a745',
                    color: '#ffffff',
                    border: '1px solid #28a745',
                    borderRadius: '4px',
                    padding: '8px 16px',
                    cursor: 'pointer',
                  }}
                >
                  Confirm
                </button>
              </DialogActions>

            </Dialog>
          </Table>
         

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              '& .MuiTablePagination-toolbar': {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'nowrap', // Ensures everything stays in one line
                minHeight: '40px', // Keeps a proper height
              },
              '& .MuiTablePagination-selectLabel': {
                marginBottom: 0, // Fixes label misalignment
              },
              '& .MuiTablePagination-displayedRows': {
                marginBottom: 0, // Fixes row count misalignment
              },
            }}
          />
        </TableContainer>
      </div>

    </div>
  );
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export default PositionIndex;